import { request_v2 } from '../utils/axios-utils';
import { useQuery, useMutation } from 'react-query';

const GetShootFilesForSku = async skuId => {
    const { data } = await request_v2({
        method: 'get',
        url: `/guideline/getSkuShootFiles/${skuId}`,
    });
    return data;
};

export const useGetShootFilesForSku = skuId =>
    useQuery(['shootFiles', skuId], () => GetShootFilesForSku(skuId), {
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    });
